import React from "react";
import Ourvisionabout from "../components/Aboutus/Ourvision";


const Ourvisionaboutpage = () => {
  return (
    <>
    <Ourvisionabout/>     
    </>

  )
};

export default Ourvisionaboutpage;